/**
 * Centralized z-index scale. Add new layers here to keep stacking order visible.
 * Higher number = closer to user.
 */
export const Z_INDEX = {
    TOAST: 10002,
    OUT_OF_SYNC_BANNER: 10001,
    DEEP_LINK_BANNER: 10001,
    HEADER_DROPDOWN: 10001,
    HEADER: 10000,
    SIDE_DRAWER_BODY_EXTENSION: 9999,
    MODAL_ABOVE_DRAWER: 9000,
    LOADING_SCREEN: 99,
} as const;
